import React from "react"

import Footer from "./Footer"
import Header from "./Header"

export default function Holygrail({
  children,
  noBacklink,
  noFooter,
  noHeader,
  noShell,
}: {
  children: React.ReactNode
  noBacklink?: boolean
  noFooter?: boolean
  /** Hide the top header (landing). */
  noHeader?: boolean
  /** Legacy alias used by auth/error: hide header chrome. */
  noShell?: boolean
}) {
  const hideHeader = Boolean(noHeader || noShell)

  return (
    <div className="flex min-h-screen w-full flex-col bg-background">
      {!hideHeader && <Header noBacklink={noBacklink} />}
      <main
        className={`min-h-0 flex-1 w-full overflow-y-auto bg-background ${hideHeader ? "" : "pt-header"}`}
      >
        {children}
      </main>
      {!noFooter && <Footer />}
    </div>
  )
}
